import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ValveGlyph = /*#__PURE__*/createElement("g", {
  id: "valve"
}, /*#__PURE__*/createElement("path", {
  d: "M68.5 27.5c-.6-.3-1.4-.3-2 .2L46.7 40.8c-.6-1.4-1.8-2.5-3.3-3v-3.4h6.3c1.3 0 2.4-1.1 2.4-2.4V16.7c0-1.3-1.1-2.4-2.4-2.4H34.3c-1.3 0-2.4 1.1-2.4 2.4v15.4c0 1.3 1.1 2.4 2.4 2.4h6.3v3.4c-1.5.4-2.7 1.5-3.3 3L17.6 27.7c-.7-.4-1.4-.5-2-.2-.6.3-1 1-1 1.8v26.8c0 .8.4 1.5 1 1.8.3.1.6.2.9.2.4 0 .8-.1 1.2-.4l19.7-13.1c.5 1.2 1.4 2.2 2.7 2.8L27 66.7c-.4.7-.5 1.4-.2 2s1 1 1.8 1h26.8c.8 0 1.5-.4 1.8-1 .3-.6.3-1.4-.2-2L44 47.3c1.2-.5 2.2-1.5 2.7-2.8l19.7 13.1c.4.3.8.4 1.2.4.3 0 .6-.1.8-.2.6-.3 1-1 1-1.8V29.3c.1-.8-.3-1.5-.9-1.8zm-33.8 4.1V17.1h14.6v14.6H34.7zM17.4 54.4V30.9L35 42.7 17.4 54.4zm12.9 12.5L42 49.3l11.7 17.6H30.3zm36.3-12.5L49 42.7 66.6 31v23.4z"
}));
const Valve = createSvg({
  name: 'valve',
  path: ValveGlyph
});

export default Valve;
export { ValveGlyph };
